import Ajax from '../ajax';

export default {
  list: (filter) => Ajax('get', 'shoppingGuide', filter),
  get: (id) => Ajax('get', `shoppingGuide/${id}`),
  add: (parameter) => Ajax('post', 'shoppingGuide', parameter),
  edit: (id, parameter) => Ajax('put', `shoppingGuide/${id}`, parameter),
};
